var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43 43",
    style: {
      enableBackground: "new 0 0 43 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3FCAEA;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,24.9c1.9,1.4,2.6,1.6,4.2,3.8c2.6,3.6,2.2,5,3,5.7c0.8,0.7,4.3,1.2,6.7-1.9c2.4-3.1,6.2-11.6,11-16.7 c4.8-5.1,7.1-6.6,8.5-7.4C40,7.6,35.4,7.8,26.3,15c-6.3,5-10.7,11.9-10.7,11.9s-1.3-3.8-4.1-6.3C8.8,18.1,1.9,22.5,5,24.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.b0fc3b2de7f7172a348c75302507ae82.svg";
export { ForwardRef as ReactComponent };